import * as yup from "yup";

export const applyCouponSchema = yup.object().shape({
  applyCouponCode: yup
    .string()
    .min(3, "Coupon code must be at least 3 characters")
    .max(10, "Coupon code cannot be more than 10 characters"),
});
